if (!customElements.get('product-form-attributes')) {
    customElements.define(
        'quantity-options',
        class ProductFormAttributes extends HTMLElement {
            constructor() {

                super();

                this.quantity_selector = this.querySelector('.quantity__options-container');
                this.quantity_selector.addEventListener('click', this.onInputHandler.bind(this));

            }
            onInputHandler(evt) {

                const button = evt.target.closest('.quantity__option');

                if (!button) return;

                let priceElement = button.querySelector('.quantity__option__sale-price');

                if (!priceElement) {
                    priceElement = button.querySelector('.quantity__option__price');
                }

                if (priceElement) {

                    const ll_price_span = document.querySelector('.ll-price-span');

                    if (!ll_price_span) {
                        return;
                    }

                    const price_text = priceElement.textContent.trim();
                    ll_price_span.textContent = price_text;
                }
            }
        }
    )
}